import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Select, Upload } from "antd";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { PostQuizApi } from "api/getQuiz";
import {
  openNotificationWithIcon,
  validateMessages,
} from "../../../../Function";

const ModalCreateQuiz = ({
  open,
  onCancel,
  arrTypeQuestion,
  setSelectedGroup,
  fetchDataQuiz,
}) => {
  const [form] = Form.useForm();
  const [fileQuiz, setFileQuiz] = useState([]);

  useEffect(() => {
    form.resetFields();
    setFileQuiz([]);
  }, [open]);

  const onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("question_type", values.question_type);
    if (fileQuiz != undefined) {
      fileQuiz.forEach((element) => {
        data.append("file", element.originFileObj);
      });
    }
    PostQuizApi(data)
      .then((res) => {
        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          openNotificationWithIcon("success", res.data.message);
          form.resetFields();
          setFileQuiz([]);
          setSelectedGroup(values.question_type);
          onCancel();
          fetchDataQuiz({
            question_type: values.question_type,
          });
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChangeUpload = (info) => {
    let thisFileList = [...info.fileList];
    if (thisFileList.length > 0) {
      setFileQuiz([thisFileList[thisFileList.length - 1]]);
    }
    if (thisFileList.length === 0) {
      setFileQuiz([]);
      form.setFieldsValue({
        file: undefined,
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Tạo đề thi"
      style={{ minWidth: "300px" }}
      width={500}
      footer={false}
      bodyStyle={{ paddingTop: 6 }}
      className={"site-drawer-render-in-current-wrapper"}
      maskClosable={false}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="Nhóm thi"
              name="question_type"
              rules={[{ required: true }]}
            >
              <Select>
                {arrTypeQuestion &&
                  arrTypeQuestion.map((item, index) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.note} ({item.loai_cau_hoi})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="File đề thi"
              name="file"
              rules={[
                { required: true, message: "Vui lòng tải lên file đề thi." },
              ]}
            >
              <Upload
                accept=".xlsx"
                onChange={handleChangeUpload}
                fileList={fileQuiz}
                maxCount={1}
                // className={"styleUploadExcel"}
                beforeUpload={(file) => {
                  return false;
                }}
              >
                <Button type="dashed" htmlType="button">
                  Tải lên
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
          <Button type="success" htmlType="submit" className={"m-2"}>
            Tạo
          </Button>
          <Button onClick={onCancel}>Thoát</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalCreateQuiz;
